import {defineField} from 'sanity'
import image from './image'
import defaultBlocks from './default-blocks'

export default defineField({
  name: 'portableTextContent',
  type: 'array',
  of: [
    defaultBlocks,
    image,
    {type: 'oembed'},
    {type: 'quote'},
    {type: 'inline-banner'},
    {type: 'related-cruises'},
    {type: 'media-text'},
    {type: 'download-file'},
    {type: 'button-link'},
  ],
})
